/*
 * @Author: Gaho
 * @Date: 2023-12-29 14:36:37
 * @LastEditors: Gaho
 * @LastEditTime: 2023-12-29 14:41:39
 */
const s = {
    ballDistance: 24.5,
    diameter: 12.4,
    numRows: 11,
    ballProp: {
        mass: 1.1,
        densety: .9,
        friction: {
            x: .97,
            y: .93
        }
    },
    xps: {
        0: [360.9420570884699, 323.55337767970923, 323.43445700131764, 360.99118746663896, 323.41990949744815, 360.3376865754766, 323.97111901134184, 322.30801127272656],
        1: [322.80371712762474, 320.56621248812814, 324.1454446989225, 324.4189963866033, 324.1548801336807, 323.0210891227466, 361.00697981775164, 323.5731908099872],
        2: [360.00145007929285, 324.46313892491145, 360.773401897482, 323.8483092569079, 324.17512091716685, 324.37518321381395, 359.3489711641391, 361.0261561326798],
        3: [357.7746249212831, 358.79689762241026, 323.31553242934206, 324.4145641861033, 358.75624489632963, 321.499369029264, 323.6909541115077, 323.8436680657693],
        4: [320.73294223529064, 322.6676277549468, 321.9185655099121, 321.38037910322396, 322.18477223792377, 324.27492190424334, 324.3538943474577, 358.80615085967975],
        5: [359.28551650636166, 324.33150302719247, 359.9104786331357, 357.6109013012714, 357.56097541170135, 323.53642127793745, 360.6404086046254, 322.78883904446303],
        6: [320.9387904042507, 358.38782421290523, 360.63448890672447, 361.2234414815792, 357.8133689421328, 320.88226689672985, 322.5929760405006, 324.01020851333425],
        7: [323.6431085160438, 358.4702987782294, 360.53847730756127, 359.7569971025638, 360.7388529191518, 323.59244091788037, 358.4566188551364, 358.68321519292545],
        8: [358.66840603021836, 321.7851323823541, 358.1819866512372, 322.62800958471894, 358.9264357407439, 360.12201449035507, 320.71151119398735, 322.10293317898487],
        9: [320.87221967929474, 321.71116285154903, 321.152790448662, 323.7873037716576, 322.6918942653136, 358.95291354632263, 321.1305659941786, 320.9427621493469],
        10: [360.6676701395889, 358.4847057559649, 358.9560518402931, 358.10014714070127, 360.09398720216547, 324.4413117597304, 358.5360508486056, 321.9915039397281],
        11: [321.9942467484765, 357.80901397267405, 358.12955156634996, 357.9714338097534, 359.1841766918233, 360.60527144934883, 359.6170041470511, 357.5375314941202],
        12: []
    }
};
export {s as default};
